module.exports = __webpack_public_path__ + "media/images/front/programs/icon-close-5634132e6e0e318059d781fa6a9c4754.svg";